import { ITenForceWindow } from "../global"

declare let window: ITenForceWindow

export const getWorkspaceId = window.env.getWorkspaceId
